import React from 'react';

import { images } from '../../constants';
import './Header.css';
import { SubHeading } from '../../components';

const Header = () => (
  <div className='app__header app__bg app__wrapper section__padding' id="home">
    <div className='app__wrapper_info'>
      <SubHeading title='The Wellness Enhancements of Beauties' />
      <h1 className='app__header-h1'>Divine Nail Spa</h1>
      <p className='p__opensans' style={{ margin: '2rem 0' }}>~ We are open everyday for your convenience ~</p>
        
      <a href="#service" className="custom__button">
  Salon Services
</a>

    </div>

    <div className='app__wrapper_img'>
      <img src={images.salon01} alt='header img' />
    </div>
  </div>
);

export default Header;
